export type Translations = Record<string, string>;

let translations: Translations = {};

export type Language =
    | 'en'
    | 'bg'
    | 'vn'
    | 'cn'
    | 'ua'
    | 'fr'
    | 'lt'
    | 'pl'
    | 'ru'
    | 'es'
    | 'de'
    | 'tr'
    | 'ch';

export type LanguageFileName =
    | 'pospublic'
    | 'dineq';

export const loadLanguage = (_lang: string) => {
    const lang = _lang as Language;
    let translationsPromise: Promise<{ default: Translations }>;

    switch(lang) {
        case 'bg':
            translationsPromise = import('./bg/global.json');
            break;
        case 'ch':
            translationsPromise = import('./ch/global.json');
            break;
        case 'de':
            translationsPromise = import('./de/global.json');
            break;
        case 'en':
            translationsPromise = import('./en/global.json');
            break;
        case 'es':
            translationsPromise = import('./es/global.json');
            break;
        case 'fr':
            translationsPromise = import('./fr/global.json');
            break;
        case 'lt':
            translationsPromise = import('./lt/global.json');
            break;
        case 'pl':
            translationsPromise = import('./pl/global.json');
            break;
        case 'ru':
            translationsPromise = import('./ru/global.json');
            break;
        case 'tr':
            translationsPromise = import('./tr/global.json');
            break;
        case 'ua':
            translationsPromise = import('./ua/global.json');
            break;
        case 'cn':
            translationsPromise = import('./zh/global.json');
            break;
        case 'vn':
            translationsPromise = import('./vn/global.json');
            break;
        default:
            translationsPromise = import('./en/global.json');

    }

    return translationsPromise
        .then((_translationsModule) => {
            const _translations = _translationsModule.default;
            translations = _translations;
            return _translations
        });
};

export const loadErrorsTranslations = (lang: string): Promise<Translations> => {
    let translationsPromise: Promise<{ default: Translations }>;

    switch(lang) {
        case 'ch':
            translationsPromise = import('./ch/errors.json');
            break;
        case 'lt':
            translationsPromise = import('./lt/errors.json');
            break;
        case 'ru':
            translationsPromise = import('./ru/errors.json');
            break;
        case 'tr':
            translationsPromise = import('./tr/errors.json');
            break;
        case 'bg':
        case 'de':
        case 'en':
        case 'es':
        case 'fr':
        case 'pl':
        case 'ua':
        case 'cn':
        default:
            translationsPromise = import('./en/errors.json');

    }

    return translationsPromise
        .then((_translations: { default: Translations }) => {
            translations = _translations.default;
            return _translations.default;
        });
};

export const loadSpecificLanguageFiles = (lang: Language, types: LanguageFileName[]): Promise<Translations> => {
    return new Promise((resolve) => {
        const promises = types.map((type) => getMappedFile(lang, type));

        Promise.all(promises)
            .then((results) => {
                results.forEach((r) => {
                    translations = { ...translations, ...r };
                });
                resolve(translations);
            });


    })

}

export const getCurrentTranslations = () => translations;

export const overrideTranslations = (data: { [key: string]: string }) => {
    translations = { ...translations, ...data };

    return translations;
};

function getMappedFile(lang: Language, type: LanguageFileName): Promise<Translations> {
    return new Promise<Translations>((resolve) => {
       switch (type) {
           case 'pospublic':
               switch (lang) {
                   case 'en':
                       import('./en/pospublic.json')
                           .then((res) => resolve(res.default));
                       break;
                   case 'lt':
                       import('./lt/pospublic.json')
                           .then((res) => resolve(res.default));
                       break;
                   default:
                       return resolve({});
               };
               break;
           case 'dineq':
               switch (lang) {
                   case 'en':
                       import('./en/dineq.json')
                           .then((res) => resolve(res.default));
                       break;
                   case 'lt':
                       import('./lt/dineq.json')
                           .then((res) => resolve(res.default));
                       break;
                   default:
                       return resolve({});
               };
               break;
           default:
               return resolve({});
       }
    });
}
